import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const itineraryApi = createApi({
  reducerPath: "itineraryApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API,
    prepareHeaders: (headers) => {
      const user = localStorage.getItem('hthUser');
      const token = user ? JSON.parse(user).token : null;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAllItinerary: builder.query({
      query: (tourId) => ({
        url: `/api/admin/getAllItinerary/${tourId}`,
        method: "GET",
      }),
    }),
    addEditItinerary: builder.mutation({
      query: (formData) => ({
        url: "/api/admin/addEditItinerary",
        method: "POST",
        body: formData,
        formData: true,
      }),
    }),
  }),
});

export const { useGetAllItineraryQuery, useAddEditItineraryMutation } = itineraryApi;
